import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function Home() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-50 to-white flex flex-col items-center justify-center p-6">
      {/* Hero Section */}
      <div className="max-w-4xl text-center space-y-6">
        {/* Logo/Title */}
        <div className="flex items-center justify-center gap-2">
          <svg className="w-10 h-10 text-indigo-600" fill="currentColor" viewBox="0 0 20 20">
            <path d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v1h8v-1zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-1a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v1h-3zM4.75 12.094A5.973 5.973 0 004 15v1H1v-1a3 3 0 013.75-2.906z" />
          </svg>
          <h1 className="text-5xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-indigo-600 to-purple-600">
            AjoX
          </h1>
        </div>

        {/* Tagline */}
        <h2 className="text-3xl md:text-4xl font-semibold text-gray-800">
          Save Together, Grow Together
        </h2>

        {/* Description */}
        <p className="text-lg md:text-xl text-gray-600 leading-relaxed">
          AjoX digitizes traditional community savings (<span className="font-medium">Ajo/Esusu</span>) with 
          secure payments, automated tracking, and <span className="text-indigo-600 font-medium">zero scams</span>. 
          Join thousands of Nigerians building wealth in circles they trust.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center pt-4">
          <button
            onClick={() => navigate('/signup')}
            className="px-6 py-3 bg-indigo-600 hover:bg-indigo-700 text-white font-medium rounded-lg shadow-md transition-all duration-200 transform hover:scale-105"
          >
            Start a Savings Circle
          </button>
          <button
            onClick={() => navigate('/explore')}
            className="px-6 py-3 border-2 border-indigo-600 text-indigo-600 hover:bg-indigo-50 font-medium rounded-lg transition-all"
          >
            Explore Groups
          </button>
        </div>

        {/* Trust Indicators */}
        <div className="pt-8 flex flex-col items-center space-y-3">
          <div className="flex -space-x-2">
            {[1, 2, 3, 4].map((i) => (
              <img
                key={i}
                src={`https://randomuser.me/api/portraits/women/${i+20}.jpg`}
                alt="User"
                className="w-10 h-10 rounded-full border-2 border-white"
              />
            ))}
          </div>
          <p className="text-sm text-gray-500">
            Trusted by <span className="font-medium">5,000+</span> savers across Nigeria
          </p>
        </div>
      </div>

      {/* Feature Preview (Mockup) */}
      <div className="mt-16 p-6 bg-white rounded-xl shadow-lg border border-gray-100 max-w-2xl">
        <img 
          src="/ajo-mockup.png" // Replace with actual image
          alt="AjoX Mobile App Preview"
          className="rounded-lg border border-gray-200"
        />
      </div>
    </div>
  );
}